import type { AuctionData } from "../../../core/AdEnginePlugin";
import { PrebidBidderAdapter } from "./PrebidBidderAdapter";

/**
 * @deprecated The global prebid config of `pbjs.getConfig("appnexusAuctionKeywords")`
 * should be used instead to set the page targeting for the whole auction,
 * reducing the data send in the bid request.
 *
 * Custom adapter for AppNexus bidder to add the page targeting to
 * `bids.params.keywords`.
 */
export class AppNexusBidderAdapter extends PrebidBidderAdapter<"appnexus"> {
  transformAdUnitBidConfigs(
    bidderConfigs: PrebidAdUnitBidForKey["appnexus"][],
    auctionData: AuctionData,
  ): PrebidAdUnitBidForKey["appnexus"][] {
    for (const bid of bidderConfigs) {
      bid.params.keywords = { ...auctionData.pageTargeting };
    }

    return bidderConfigs;
  }
}
